import { makeAutoObservable, action, toJS, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";

class Store {
    agent_info: any
    team_id: number
    constructor() {
        makeAutoObservable(this);
        makePersistable(this, {
            name: "AgentLogin",
            properties: ["agent_info", 'team_id'],
            storage: window.localStorage,
        });
    }
    @action setLoginInfo = (value) => {
        this.agent_info = value
    };
    @action setAgentTeamId = (id) => {
        this.team_id = id
    };

}

const AgentStore = new Store();
export default AgentStore;
